import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=10cd4661&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10cd4661')) {
      api.createRecord('10cd4661', component.options)
    } else {
      api.reload('10cd4661', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=10cd4661&", function () {
      api.rerender('10cd4661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eCQKJWcDnXJY/JS/comp/ImgFallback.vue"
export default component.exports